<template>
      <div>
        <v-row>
          <v-col cols="12" class="d-flex justify-center" >
            <v-img slot="image" :src="require('assets/imgs/documento_confirmacao.svg')" width="174" height="105" contain />
          </v-col>
          <v-col cols="12" class="pt-0">
            <span class="d-flex justify-center title pt-0" color="primary"> Qual o método de envio você deseja utilizar? </span>
          </v-col>
          <v-col cols="12">
            <input-select label="Escolher o método de envio" v-model="model.metodoEnvio" :options="tipoEnvio" required />
            <input-email v-model="model.email" label="E-mail" :required="model.metodoEnvio !== 'pdf'" :disabled="model.metodoEnvio === 'pdf'" />
          </v-col>
        </v-row>
      </div>
</template>

<script>
export default {
  data () {
    return {
      model: {},
      tipoEnvio: [
        { text: 'Email com PDF', value: 'email-pdf' },
        { text: 'Baixar o PDF', value: 'pdf' },
      ],
    };
  },
  methods: {
    getOpcao () {
      return this.model
    }
  }
}
</script>
